module.exports = __webpack_public_path__ + "img/main-cup.0a0a9607.png";